import { defineMessages, useIntl } from '@redbubble/next/intl';

const messages = defineMessages({
  message0: {
    defaultMessage: 'Retro mountain with trees',
  },
  message1: {
    defaultMessage: 'Cats and funny memes',
  },
  message2: {
    defaultMessage: 'Cars and auto racing',
  },
  message3: {
    defaultMessage: 'Fantasy dragons and magic',
  },
  message4: {
    defaultMessage: 'Black and white sci-fi',
  },
  message5: {
    defaultMessage: 'Puns and memes and funny sayings',
  },
  message6: {
    defaultMessage: 'Retro 70s and 80s nostalgia',
  },
  message7: {
    defaultMessage: 'Flowers and gardening',
  },
  message8: {
    defaultMessage: 'Mind and wellness quotes',
  },
  message9: {
    defaultMessage: 'Pastel art nouveau',
  },
});

export const useEngageTextMessaging = (): string[] => {
  const intl = useIntl();

  return Object.keys(messages).map((key) => intl.formatMessage(messages[key]));
};
